import React, { FC } from 'react';
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Button } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import ModalLoader from './ModalLoader';
import { Direction } from 'reactstrap/types/lib/Offcanvas';

interface OffcanvasModalProps {
    open: boolean;
    toggle: () => void;
    direction?: Direction;
    OffcanvasModalID: string;
    modalClassName: string;
    modalHeaderClassName?: string;
    header?: boolean;
    headerBgColor?: boolean;
    offcanvasHeader?: string;
    loading: boolean;
    bodyCSSClass?: string;
    handleOffcanvasBody: () => JSX.Element;
    hideFooterButtons?: boolean;
    cancelText?: string;
    handleCloseClick: () => void;
    hideSaveButton?: boolean;
    saveDisabled?: boolean;
    handleSaveClick?: () => void;
    saveText?: string;
    customFooter?: boolean;
    customFooterBody?: any;
    validation?: any;
}

const OffcanvasModal: FC<OffcanvasModalProps> = (props) => {
    return (
        <React.Fragment>
            <Offcanvas
                backdrop={true}
                isOpen={props.open}
                toggle={props.toggle}
                direction={props.direction}
                id={props.OffcanvasModalID}
                className={`border-0 offcanvas-${props.direction} ${props.modalClassName}`}
            >
                {!props?.header && (
                    <OffcanvasHeader
                        className={`d-flex align-items-center ${
                            props.headerBgColor ? 'bg-primary p-4 offcanvas-header-dark' : ''
                        }  height-50`}
                        toggle={props.toggle}
                    >
                        <span
                            className={`m-0 me-2 ${
                                props.modalHeaderClassName ? props.modalHeaderClassName : 'text-white'
                            } fw-semibold fs-5`}
                        >
                            {props.offcanvasHeader}
                        </span>
                    </OffcanvasHeader>
                )}
                <OffcanvasBody className="p-1">
                    {props.loading && <ModalLoader />}
                    <SimpleBar className="h-100">
                        {<div className={props.bodyCSSClass ? props.bodyCSSClass : 'p-2'}>{props.handleOffcanvasBody()}</div>}
                    </SimpleBar>
                </OffcanvasBody>
                {!props.hideFooterButtons && (
                    <div className="offcanvas-footer  p-4 gap-3 d-flex justify-content-end">
                        <Button outline className="w-sm" color="primary" data-bs-dismiss="modal" onClick={props.handleCloseClick}>
                            {props.cancelText ? props.cancelText : 'Close'}
                        </Button>

                        {!props.hideSaveButton && (
                            <button
                                type="button"
                                className="btn w-sm btn-primary"
                                disabled={props.saveDisabled}
                                onClick={() => {
                                    props.validation && props.validation.submitForm();
                                    props.handleSaveClick && props.handleSaveClick();
                                }}
                            >
                                {props.saveText ? props.saveText : 'OK'}
                            </button>
                        )}
                    </div>
                )}
                {props.customFooter && props.customFooterBody()}
            </Offcanvas>
        </React.Fragment>
    );
};

export default OffcanvasModal;
